export default __webpack_public_path__ + "static/media/service_cloud.3bac0b17.png";